import styled from 'styled-components'
import { colors } from 'client/styles'
import { MEDIUM_SIZE, SMALL_SIZE } from './constants'

export const BedTypeBase = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  font-size: 14px;

  color: ${colors.grey2};
  ${props => props.size === MEDIUM_SIZE && 'font-size: 16px'};
  ${props => props.size === SMALL_SIZE && 'font-size: 14px'};
`

export const BedsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-inline-start: 10px;
`

export const Title = styled.div`
  ${props => props.size === SMALL_SIZE && 'margin-block-start: 4px'};
  > p {
    &::after {
      content: ':';
    }
  }
`

export const BedWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const IconWrapper = styled.div`
  padding-inline-end: 8px;
  align-items: flex-end;
  width: auto;

  svg {
    fill: ${colors.grey2};
  }
`

export const Separator = styled.div`
  display: flex;
  justify-content: center;
  width: 12px;
  padding-inline: 4px;
`

export const BedDescription = styled.div`
  display: flex;
`
